<template>
  <div class="sw--height-full sw-dms--bg-grey-96">
    <div v-if="isVizProcessing" class="sw--position-relative sw--height-full sw-grid-flex__cell sw--height-full">
      <div class="sw-loading-animation sw--font-size-18 sw--position-absolute sw--position-fill"></div>
    </div>
    <div v-else-if="isVizAvailable && glbPath"
      class="printability-center-viz sw-grid-flex--tab sw-grid-flex--justify-center--tab sw--height-full"
      id="boundingBoxViz">
      <sw-viewer
        :src="glbPath"
        viewer="model-viewer"
        up-axis="Y"
        rotation="0 1 0 -0.349"
        orbit-mode="turntable"
        material="default"
        viewer-attributes="camera-orbit=auto 75deg auto&shadow-intensity=0.5&shadow-softness=0.6&field-of-view=15deg"
        show-grid="false"
        show-axes="false"
      />
      <img :src="pictureUrl"
        class="sw--display-none sw--display-block--tab sw--height-auto sw--width-auto sw--max-height-250px--tab"/>
        <script type="module" src="/rrstatic/javascript/sw-viewer.js"></script>
    </div>
    <div v-else-if="isVizAvailable && aoptPath"
      class="printability-center-viz sw-grid-flex--tab sw-grid-flex--justify-center--tab sw--height-full"
      id="boundingBoxViz">
      <iframe id="automated-printability-checks-asset-aopt-bounding-box-iframe"
        scrolling="no"
        class="printability-center-bounding-box-iframe sw--display-none--tab"
        frameborder="0"
        :src="aoptPath"
        data-sw-3d-tools-viz-iframe>
      </iframe>
      <img :src="pictureUrl"
        class="sw--display-none sw--display-block--tab sw--height-auto sw--width-auto sw--max-height-250px--tab"/>
    </div>
    <div v-else-if="isVizUnavailable"
      class="sw--height-full sw-grid-flex sw-grid-flex--align-center sw-grid-flex--justify-center sw--height-full">
      <div class="sw-dms--text-light">Visualization Not Currently Available.</div>
    </div>
  </div>
</template>

<script>
  export const GrayRenderVizStatus = Object.freeze({
    NOT_AVAILABLE: 'notAvailable',
    AVAILABLE: 'vizAvailable',
    PROCESSING: 'vizProcessing'
  });

  export default {
    name: 'model-fix-gray-render-viz',

    props: {
      aoptPath: {
        type: String
      },
      glbPath: {
        type: String
      },
      grayRenderVizStatus: {
        type: String,
        required: true,
        default: GrayRenderVizStatus.PROCESSING,
        validator: value => {
          return Object.values(GrayRenderVizStatus).includes(value);
        }
      },
      pictureUrl: {
        type: String
      }
    },

    computed: {
      isVizProcessing: function () {
        return this.grayRenderVizStatus === GrayRenderVizStatus.PROCESSING
      },
      isVizAvailable: function () {
        return this.grayRenderVizStatus === GrayRenderVizStatus.AVAILABLE
      },
      isVizUnavailable: function () {
        return this.grayRenderVizStatus === GrayRenderVizStatus.NOT_AVAILABLE
      }
    }
  }
</script>
